// @flow

import * as React from 'react';
import classNames from 'classnames';

import Group from 'sail/Group';
import Icon from 'sail/Icon';

import {useAccount, useArticle} from 'docs/data';
import {useStripeClui} from '../../helpers/react/provider';

import './StripeShellToggle.scss';

const StripeShellToggle = () => {
  const {account} = useAccount();
  const {open} = useStripeClui();
  const {article} = useArticle();

  const isIntegrationBuilder = article.metadata?.type === 'integration-builder';
  const shouldRender =
    account?.flags?.clui_v1_rollout &&
    account?.flags?.stripe_shell_docs_wide_toggle;

  return shouldRender ? (
    <div
      className={classNames(
        'StripeShellToggle__container',
        isIntegrationBuilder &&
          'StripeShellToggle__integrationBuilder__container',
      )}
    >
      <button
        type="button"
        className="StripeShellToggle__button"
        aria-label="Open the Stripe Shell"
        onClick={open}
      >
        <Group direction="horizontal" spacing={8} alignItems="center">
          <Icon icon="api" size={16} color="gray500" />
          <Icon icon="chevronUp" size={10} color="gray500" />
        </Group>
      </button>
    </div>
  ) : null;
};

export default StripeShellToggle;
